import React from "react";
import { useAppSelector } from "store/hooks";
import { selectLeavePeriodById } from "store/reducers";

type LeavePeriodComponentProps = {
  leavePeriodId: number;
};

export function LeavePeriod({ leavePeriodId }: LeavePeriodComponentProps) {
  const leavePeriod = useAppSelector((state) => selectLeavePeriodById(state, leavePeriodId));

  if (!leavePeriod) {
    return null;
  }
  const title = `In the Pay Period ending on ${leavePeriod.xero_PayPeriodEndDate}`;
  return <span title={title}>{leavePeriod.xero_NumberOfUnits}h</span>;
}
